import React from 'react';
import useFadeIn from '../hooks/useFadeIn';
import features from '../data/features';

export default function FeaturesGrid() {
  const [ref, visible] = useFadeIn(0.1);

  return (
    <section className="features-section" aria-label="Coming soon features">
      <div className="section-inner">
        <div ref={ref} className={`features-header fade-up ${visible ? 'visible' : ''}`}>
          <div>
            <span className="section-eyebrow">Coming Soon</span>
            <h2 className="section-title">
              The complete execution<br />stack for India.
            </h2>
          </div>
          <p className="features-header-desc">
            From first send to final evidence record — built for the
            way India actually works, with WhatsApp, Aadhaar, and DSC
            as first-class citizens.
          </p>
        </div>

        <div className="features-table" role="list">
          {features.map(({ Icon, title, desc }, i) => (
            <div
              key={title}
              className="feature-row"
              role="listitem"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="feature-row-icon" aria-hidden="true">
                <Icon size={17} />
              </div>
              <h3 className="feature-row-title">{title}</h3>
              <span className="feature-row-badge">Soon</span>
              <p className="feature-row-desc">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
